import { useState } from "react";
import { AREA_GROUPS } from "@/lib/areas";
import { SERVICE_NAMES } from "@/lib/services";
import { MapPin, HandHeart } from "lucide-react";

function Chip({ on, label, onClick, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={`rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${on ? "border-brand bg-brand text-white" : "border-border bg-white text-ink hover:bg-brand-light"}`}>
      {label}
    </button>
  );
}

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function WorkPrefsEditor({ value, onChange }) {
  const [openGroup, setOpenGroup] = useState(null);
  const areas = value.work_areas || [];
  const svcs = value.offered_services || [];
  const toggle = (key, list, item) => onChange({ ...value, [key]: list.includes(item) ? list.filter((x) => x !== item) : [...list, item] });
  const toggleGroup = (towns) => {
    const all = towns.every((t) => areas.includes(t));
    onChange({ ...value, work_areas: all ? areas.filter((a) => !towns.includes(a)) : [...new Set([...areas, ...towns])] });
  };
  return (
    <div className="space-y-5" data-testid="work-prefs-editor">
      <div>
        <p className="mb-2 flex items-center gap-1.5 text-sm font-semibold text-ink"><MapPin size={15} className="text-brand" /> Areas I can work in <span className="font-normal text-ink-muted">({areas.length} selected)</span></p>
        <div className="space-y-1.5">
          {AREA_GROUPS.map(([group, towns]) => {
            const n = towns.filter((t) => areas.includes(t)).length;
            const open = openGroup === group;
            return (
              <div key={group} className="rounded-lg border border-border">
                <div className="flex items-center justify-between gap-2 px-3 py-2">
                  <button type="button" onClick={() => setOpenGroup(open ? null : group)} data-testid={`area-group-${slug(group)}`} className="flex-1 text-left text-sm font-medium text-ink">
                    {group} {n > 0 && <span className="ml-1 rounded-full bg-brand-light px-1.5 text-[11px] font-semibold text-brand">{n}</span>}
                  </button>
                  <button type="button" onClick={() => toggleGroup(towns)} data-testid={`area-group-all-${slug(group)}`} className="text-xs font-semibold text-brand">{n === towns.length ? "Clear" : "Select all"}</button>
                </div>
                {open && (
                  <div className="flex flex-wrap gap-1.5 border-t border-border px-3 py-2">
                    {towns.map((t) => <Chip key={t} on={areas.includes(t)} label={t} onClick={() => toggle("work_areas", areas, t)} testid={`area-chip-${slug(t)}`} />)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <p className="mb-2 flex items-center gap-1.5 text-sm font-semibold text-ink"><HandHeart size={15} className="text-brand" /> Services I can offer</p>
        <div className="flex flex-wrap gap-1.5">
          {SERVICE_NAMES.map((s) => <Chip key={s} on={svcs.includes(s)} label={s} onClick={() => toggle("offered_services", svcs, s)} testid={`service-chip-${slug(s)}`} />)}
        </div>
      </div>
    </div>
  );
}

export function matchInfo(carer, client) {
  if (!carer || !client) return null;
  const areaOk = !client.area || (carer.work_areas || []).includes(client.area);
  const missing = (client.befriending_services || []).filter((s) => !(carer.offered_services || []).includes(s));
  return { good: areaOk && missing.length === 0, areaOk, missing };
}
